export function setUserToken(token){
  window.localStorage.setItem('auth-token', token)
}

export function getUserToken(){
  return window.localStorage.getItem('auth-token')
}